if (!customElements.get('product-card')) {
class ProductCard extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback(){
    this.inited = false;
    this.classList.add('not-initialized');
    this.currentMode = null;
    this.initByViewport();

    this.preCheckSwiperArrow();
    const isDesktopLike =
      window.matchMedia('(hover: hover)').matches &&
      window.matchMedia('(pointer: fine)').matches;

    if(!isDesktopLike){
      this.onResize = this.debounce(() => {
        this.inited = false;
        this.initByViewport();
      }, 200);

      window.addEventListener('resize', this.onResize);
    }
  }
  initByViewport(){
    const isDesktop = window.innerWidth > 768;
    const isDesktopLike =
      window.matchMedia('(hover: hover)').matches &&
      window.matchMedia('(pointer: fine)').matches;
    const newMode = isDesktopLike ? 'desktop' : 'mobile';

    // if (this.currentMode === newMode) return;
    // this.currentMode = newMode;

    if (isDesktopLike) {
      this.bindHoverInit();
    } else {
      this.bindViewportInit();
    }

    const lazyImages = this.querySelectorAll("img.lazy-img");

    if ("IntersectionObserver" in window) {
      let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            let img = entry.target;
            img.src = img.dataset.src;
            // img.removeAttribute("data-src");
            lazyImageObserver.unobserve(img);
          }
        });
      });

      lazyImages.forEach(function (img) {
        lazyImageObserver.observe(img);
      });
    } else {
      lazyImages.forEach(function (img) {
        img.src = img.dataset.src;
      });
    }
  }
  preCheckSwiperArrow() {
    const swiperContainer = this.querySelector(".product-card-variants");
    const variantItems = this.querySelectorAll(".product-card-variants .swiper-wrapper label");
    if (!swiperContainer || variantItems.length === 0) {
      this.classList.add("no-swiper");
      return;
    }

    const containerWidth = swiperContainer.clientWidth;
    let totalItemsWidth = 0;
    variantItems.forEach(item => {
      totalItemsWidth += item.offsetWidth;
    });

    this.classList.toggle("no-swiper", totalItemsWidth <= containerWidth);
  }

  bindViewportInit() {
    if (this.inited) return;

    if (!('IntersectionObserver' in window)) {
      this.initAll();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.inited) {
          this.initAll();
          observer.unobserve(this);
        }
      });
    }, {
      root: null,
      threshold: 0.2
    });

    observer.observe(this);
  }

  bindHoverInit() {
    const productCard = this;
    if (!productCard) return;
    let isFirstHoverInit = true;

    productCard.addEventListener('mouseenter', () => {
      if (!this.inited) {
        this.initAll();
        // this.imagesSwiper?.slideNext();
        isFirstHoverInit = false;
      } else if (isFirstHoverInit) {
        this.imagesSwiper?.slideNext();
        isFirstHoverInit = false;
      }
    });

    productCard.addEventListener('click', () => {
      if (!this.inited) {
        this.initAll();
      }
    });
  }

  initAll(){
    if(!this.inited){
      this.initSwiper()
      this.initImagesSwiper()
      if(this.classList.contains("not-initialized")){
        this.initEventListener()
      }
      this.inited = true;
      this.classList.remove('not-initialized');
    }
  }

  debounce(func, delay) {
    let timer;
    return () => {
      clearTimeout(timer); 
      timer = setTimeout(() => func.call(this), delay); 
    };
  }
  
  resizeSwiper() {
    if (this.variantSwiper) {
       this.variantSwiper.destroy(true, false);
       this.variantSwiper = undefined;
    }
    this.initSwiper();
  }

  initImagesSwiper() {

    this.imagesSwiper = new Swiper(this.querySelector(".product-card-images"), {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: this.querySelector('.cust-swiper-next'),
        prevEl: this.querySelector('.cust-swiper-prev')
      },
      pagination: {
        el:this.querySelector('.cust-swiper-pagination'),
        type: "progressbar",
      }
    });
  }
  
  initSwiper(){
    if (window.innerWidth <= 768 && !this.closest(".one-column__layout")) {
      return;
    }
    const swiper_container = this.querySelector("variant-radios .active-variant__drawer");
    if(swiper_container){
      swiper_container.style.setProperty("--max-width", swiper_container.clientWidth+"px");
    }
    const swiper_container1 = this.querySelector(".swiper-wrapper");
    if(swiper_container1){
       swiper_container1.style.setProperty("gap", "0px");
    }
    this.classList.remove("no-swiper");
    const inputs = this.querySelectorAll(".product-card-variants input");
    const labels = this.querySelectorAll(".product-card-variants label");
    this.variantSwiper = new Swiper(this.querySelector(".product-card-variants"), {
      slidesPerView: 'auto',
      spaceBetween:5,
      navigation: {
        nextEl: this.querySelector('.swiper-next'),
        prevEl: this.querySelector('.swiper-prev')
      },
      on:{
        init: () => {
          const disableButtons = this.querySelectorAll("variant-radios .swiper-button-disabled");
          if(disableButtons.length == 2){
            this.classList.add("no-swiper")
          }
        },
        slideChange: () => {
          if(labels[this.variantSwiper.activeIndex]){
            labels[this.variantSwiper.activeIndex].click()
          }
        },
      },
    });
  }

  initEventListener() {


      const subscription_button = this.querySelector(".subscription-button");
      if(subscription_button){
        subscription_button.addEventListener("click", ()=>{

        })
      }
      const variantRadiosSets = this.querySelectorAll('variant-radios');

    variantRadiosSets.forEach((variantRadios) => {
        const tabsContainer = variantRadios.querySelector('.shade-category-tabs');

        if (tabsContainer !== null){
            const tabs = tabsContainer.querySelectorAll('.shade-category-tab');
            const panels = variantRadios.querySelectorAll('.shade-category-panel');

            if (tabs.length > 0) {
                const highlight = document.createElement('span');
                highlight.classList.add('tab-highlight');
                tabsContainer.appendChild(highlight);

                function setActiveTab(tab) {
                    const category = tab.dataset.category;
                    tabs.forEach(t => t.classList.remove('active'));
                    tab.classList.add('active');
                    panels.forEach(panel => {
                        panel.classList.toggle('active', panel.dataset.category === category);
                    });
                    const tabRect = tab.getBoundingClientRect();
                    const containerRect = tabsContainer.getBoundingClientRect();
                    const textContent = tab.textContent.toUpperCase();
                    const textWidth = getTextWidth(textContent, getComputedStyle(tab).font);

                    highlight.style.width = `${textWidth}px`;
                    highlight.style.left = `${tabRect.left - containerRect.left + (tabRect.width - textWidth) / 2}px`;
                }

                function getTextWidth(text, font) {
                    const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
                    const context = canvas.getContext("2d");
                    context.font = font;
                    const metrics = context.measureText(text);
                    return metrics.width;
                }

                tabs.forEach(tab => {
                    tab.addEventListener('click', () => setActiveTab(tab));
                });

                if (tabs.length > 0) {
                    setActiveTab(tabs[0]);
                }
            }
        }
    });

    const productCardImage = this.querySelector(".product-card-images");
    const productCard = this.querySelector(".card--product");

    productCardImage.addEventListener("click", (e) => {
      window.location.href = productCardImage.dataset.productUrl
    });

    productCard.addEventListener("mouseenter", () => {
      if (this.imagesSwiper) {
        this.imagesSwiper.slideNext();
      }
    });
    productCard.addEventListener("mouseleave", () => {
      if (this.imagesSwiper) {
        this.imagesSwiper.slideTo(0);
      }
    });

    if(this.querySelector("[data-oke-star-rating]") && window.okeWidgetApi){
       window.okeWidgetApi.initWidget(this.querySelector("[data-oke-star-rating]"));
    }
    const quickButtons = this.querySelectorAll(".card-buttons .atc-button");
    const quickBuyDarwer = document.querySelector("product-quick-buy")
    quickButtons.forEach(btn => {
      btn.addEventListener("click",async (e) => {
        e.preventDefault();
        e.stopPropagation();
        btn.disabled = true;
        setTimeout(() => {
          btn.disabled = false;
        },300)
        if(quickBuyDarwer){
          quickBuyDarwer.open();
          quickBuyDarwer.fetchProduct(btn.dataset.productHandle,this.dataset.variantId);
        }
      })
    })
    const viewCarts = this.querySelectorAll(".vc-button");
    viewCarts.forEach(viewCart => {
      viewCart.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        document.querySelector(".header__icon--cart").click();
      })
    });
  }

  updateButtonEvents(){
    const quickButtons = this.querySelectorAll(".card-buttons .atc-button");
    const quickBuyDarwer = document.querySelector("product-quick-buy")
    quickButtons.forEach(btn => {
      btn.addEventListener("click",async (e) => {
        e.preventDefault();
        e.stopPropagation();
        btn.disabled = true;
        setTimeout(() => {
          btn.disabled = false;
        },300)
        if(quickBuyDarwer){
          quickBuyDarwer.open();
          quickBuyDarwer.fetchProduct(btn.dataset.productHandle,this.dataset.variantId);
        }
      })
    })
    const viewCarts = this.querySelectorAll(".vc-button");
    viewCarts.forEach(viewCart => {
      viewCart.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        document.querySelector(".header__icon--cart").click();
      })
    });
  }
}

customElements.define('product-card', ProductCard);
}